module.exports = {
    title: '靖边星源LNG管理平台',

    logoText: '靖边星源LNG管理平台',

    logoUrl: 'http://pic.aplus.pub//storage/2/C20p4oruQKQWqMYXnhY3Y8c9wxNvEUp4lM6ooJFp.png',
    // logoUrl: 'http://lng-static.oss-cn-beijing.aliyuncs.com/LOGO_white.png',

    loginLogo:"http://pic.aplus.pub//storage/2/C20p4oruQKQWqMYXnhY3Y8c9wxNvEUp4lM6ooJFp.png",
    // loginLogo:"http://lng-static.oss-cn-beijing.aliyuncs.com/LOGO.png",

    loginText:"星源燃气",

    loginDesc:"LNG采销一体供应链信息平台",

    copyright:"宁夏世纪创想网络科技有限公司",

    api_version:"v1",

    /*
    * @type {boolean} true | false
    * 是否启用mock-server
     */
    openMock:true,

    /*
    * @type {string}
    * @description cookie key
     */
    cookieKey:'ApiToken',

    /**
     * @type {boolean} true | false
     * @description Whether show the settings right-panel
     */
    showSettings: false,

    /**
     * @type {boolean} true | false
     * @description Whether need tagsView
     */
    tagsView: true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: true,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    /**
     * @type {string | array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: 'development'
}
